export function getEnumSelectOptions<EnumType extends Record<string, string>>(
    enumObj: EnumType,
    labels: Record<keyof EnumType, string>,
    sortByLabel: boolean = true
) {
    const result = Object.entries(enumObj).map(([key, value]) => {
        return {
            label: labels[key],
            value,
        };
    });
    if (!sortByLabel) {
        return result;
    }

    return result.sort((a, b) => a.label.localeCompare(b.label));
}
